const purchaseInfo = (no: number) => {
    switch (no) {
        default:
            return {
                code: "OK",
                desc: "구매 리스트 조회 성공",
                result: [{
                    name: "PRO",
                    price: "20000",
                    purchase_date: "22/09/25 15:55:16",
                    expire_date: "22/10/25 15:55:16",
                    active_date: "22/03/25 15:52:28",
                    reschedule: 1,
                }],
                flag: true,
            };
    }
};

export default purchaseInfo;
    